import axios, { AxiosError } from 'axios';
import { getVisitorId } from '../utils/visitorId';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'https://localhost:5001/api/v1',
  paramsSerializer: (params: Record<string, any>) => {
    const searchParams = new URLSearchParams();
    Object.entries(params).forEach(([key, value]) => {
      if (Array.isArray(value)) {
        // serializa array como categoryIds=9&categoryIds=1&categoryIds=5
        value.forEach((v) => searchParams.append(key, String(v)));
      } else if (value !== undefined && value !== null) {
        searchParams.set(key, String(value));
      }
    });
    return searchParams.toString();
  },
});

api.interceptors.request.use((config) => {
  config.headers['X-Visitor-Id'] = getVisitorId();
  const token = localStorage.getItem('store_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error: AxiosError) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('store_token');
      window.dispatchEvent(new CustomEvent('unauthorized'));
    }
    return Promise.reject(error);
  }
);

export default api;
